export default defineNuxtRouteMiddleware(async to => {
	const routes = restrictViewRoutes.filter(obj => to.path.startsWith(obj.route))
	if (routes.length === 0) return
	const hasAccess = useUserStore().hasPermission(routes[0].permissions)
	if (!hasAccess) return await navigateTo('/panel/dashboard')
})
